<loading [visible]="loading() || saving()"></loading>

@if(!loading()){
<app-custom-modal maxWidth="7xl"
    [customTitle]="(id ? 'Editar' : 'Nuevo') + ' cliente' + (saveForm.get('id_by_company')?.value ? ' : ' + saveForm.get('id_by_company')?.value : '')"
    (closeFunction)="closeFormFunction()" (acceptFunction)="saveEntity()">

    <form [formGroup]="saveForm" (ngSubmit)="saveEntity()" class="max-w-7xl grid grid-cols-1 md:grid-cols-3 gap-2">

        <section class="md:col-span-5 border border-gray-200 shadow p-3 rounded">
            <h3 class="text-xs font-bold text-black uppercase tracking-[0.2em] border-b-2 border-black pb-2 mb-3">
                Información General
            </h3>
            <div class="grid grid-cols-1 md:grid-cols-8 gap-2">
                <div class="md:col-span-3">
                    <custom-input [autofocus]="true" label="Nombre del cliente" placeholder="Ej: Jose de los santos"
                        [formControlItem]="saveForm.get('name')"></custom-input>
                </div>
                <custom-input label="Código" placeholder="CLI-001"
                    [formControlItem]="saveForm.get('code')"></custom-input>

                <custom-input label="NIF / CIF" placeholder="12345678Z"
                    [formControlItem]="saveForm.get('nif')"></custom-input>

                <custom-select label="Tipo documento" [formControlItem]="saveForm.controls['nif_type']"
                    [options]="dropdowns.nifTypes" bindValue="code" bindLabel="name" [isMultiple]="false"
                    placeholder="Selecciona un tipo">
                </custom-select>

                <div class="md:col-span-8 grid grid-cols-1 md:grid-cols-7 gap-2">
                    <div class="md:col-span-2">
                        <custom-input label="Dirección Completa"
                            [formControlItem]="saveForm.get('address')"></custom-input>
                    </div>
                    <custom-input label="Población" [formControlItem]="saveForm.get('city')"></custom-input>
                    <custom-input label="Provincia" [formControlItem]="saveForm.get('province')"></custom-input>
                    <custom-input label="Código Postal" [formControlItem]="saveForm.get('postal_code')"
                        [errorMessages]="{ pattern: 'Debe tener 5 dígitos' }"></custom-input>
                    <custom-select label="País" [formControlItem]="saveForm.controls['country']"
                        [options]="dropdowns.countries" bindValue="code" bindLabel="name" [isMultiple]="false"
                        [tabindex]="-1" placeholder="Selecciona un país">
                    </custom-select>
                </div>

                <div class="md:col-span-2">
                    <custom-input label="Persona de Contacto"
                        [formControlItem]="saveForm.get('contact_person')"></custom-input>
                </div>

                <div class="md:col-span-3 flex flex-col md:flex-row gap-2">
                    <custom-input label="Email Principal" type="email" placeholder="ejemplo@correo.com"
                        [formControlItem]="saveForm.get('email_1')"></custom-input>

                    <custom-input label="Email Secundario" type="email" placeholder="ejemplo@correo.com"
                        [formControlItem]="saveForm.get('email_2')"></custom-input>
                </div>

                <custom-input label="Teléfono 1" [formControlItem]="saveForm.get('phone_1')"></custom-input>
                <custom-input class="md:col-span-2" label="Teléfono 2"
                    [formControlItem]="saveForm.get('phone_2')"></custom-input>

                <custom-select label="Nº Tarifa" [formControlItem]="saveForm.controls['tariff_id']"
                    [options]="dropdowns.tariffs" bindValue="id" bindLabel="name" [isMultiple]="false"
                    placeholder="Selecciona una tarifa" [createComponent]="tariffsFormComponent"
                    (itemCreated)="getDropdowns()">
                </custom-select>
                <custom-input label="Desc. Factura (%)" decimal unit="%"
                    [formControlItem]="saveForm.get('discount')"></custom-input>

                <custom-select label="Forma de pago" [formControlItem]="saveForm.controls['payment_method_id']"
                    [options]="dropdowns.payMethods" bindValue="id" bindLabel="name" [isMultiple]="false"
                    placeholder="Selecciona una Forma de pago" [createComponent]="payMethodFormComponent"
                    (itemCreated)="getDropdowns()">
                </custom-select>
                <div class="md:col-span-2">
                    <custom-input label="Reclamo Comercial"
                        [formControlItem]="saveForm.get('commercial_claim')"></custom-input>
                </div>
                <custom-input label="Cuenta Contable"
                    [formControlItem]="saveForm.get('accounting_account')"></custom-input>
            </div>
        </section>

        <section class="md:col-span-2 border border-gray-200 shadow p-3 rounded">
            <h3 class="text-xs font-bold text-black uppercase tracking-[0.2em] border-b-2 border-black pb-2 mb-3">
                Pagos y Facturación
            </h3>

            <div class="grid grid-cols-2 md:grid-cols-4 gap-4 bg-neutral-50 p-3 rounded-2xl border border-black">
                <div class="flex items-center group cursor-pointer">
                    <input type="checkbox" id="send_email" formControlName="send_email"
                        class="w-5 h-5 text-black border-2 border-black rounded focus:ring-black accent-black cursor-pointer">
                    <label for="send_email" class="ml-3 text-sm font-bold text-black cursor-pointer">
                        Enviar facturas por email
                    </label>
                </div>
                <div class="flex items-center group cursor-pointer">
                    <input type="checkbox" id="iva" formControlName="iva"
                        class="w-5 h-5 text-black border-2 border-black rounded focus:ring-black accent-black cursor-pointer">
                    <label for="iva" class="ml-3 text-sm font-bold text-black cursor-pointer">
                        IVA
                    </label>
                </div>
                <div class="flex items-center group cursor-pointer">
                    <input type="checkbox" id="equivalence_recharge" formControlName="equivalence_recharge"
                        class="w-5 h-5 text-black border-2 border-black rounded focus:ring-black accent-black cursor-pointer">
                    <label for="equivalence_recharge" class="ml-3 text-sm font-bold text-black cursor-pointer">
                        Rec. Equiv.
                    </label>
                </div>
                <div class="flex items-center group cursor-pointer">
                    <input type="checkbox" id="credit_sales" formControlName="credit_sales"
                        class="w-5 h-5 text-black border-2 border-black rounded focus:ring-black accent-black cursor-pointer">
                    <label for="credit_sales" class="ml-3 text-sm font-bold text-black cursor-pointer">
                        Venta Crédito
                    </label>
                </div>
            </div>

            <div class="grid grid-cols-2 md:grid-cols-4 gap-2 mt-3">
                <custom-input label="Día de pago 1" type="number" min="1" max="31"
                    [formControlItem]="saveForm.get('day_pay_1')"></custom-input>
                <custom-input label="Día de pago 2" type="number" min="1" max="31"
                    [formControlItem]="saveForm.get('day_pay_2')"></custom-input>
                <div class="col-span-2">
                    <custom-input label="Apartado de correos"
                        [formControlItem]="saveForm.get('mailbox_office')"></custom-input>
                </div>
            </div>
        </section>

        <section class="border border-gray-200 shadow p-3 rounded flex flex-col">
            <label class="block mb-2 text-sm font-bold text-black uppercase tracking-widest">Notas internas</label>
            <textarea tabindex="-1"
                class="w-full h-full px-4 py-4 text-sm border border-black rounded-2xl bg-white focus:outline-none focus:ring-2 focus:ring-black/5 focus:border-black transition-all min-h-30"
                rows="4" formControlName="note"
                placeholder="Escribe aquí cualquier observación relevante..."></textarea>
        </section>

    </form>
</app-custom-modal>
}